<template>
<svg width="25px" height="24px" viewBox="0 0 25 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 62 (91390) - https://sketch.com -->
    <title>unmute</title>
    <desc>Created with Sketch.</desc>
    <g id="video-and-cobrowsing" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Artboard-Copy" transform="translate(-601.000000, -338.000000)">
            <g id="unmute" transform="translate(602.000000, 338.000000)">
                <g id="Group-4-Copy" transform="translate(3.000000, 0.000000)" stroke="#ffffff">
                    <path d="M0.5,10 C0.5,11.4705882 0.647058824,12.6470588 0.941176471,13.5294118 C2.13964821,17.124827 4.6394327,18.5 8,18.5 C11.352602,18.5 13.8603518,17.124827 15.0588235,13.5294118 C15.3529412,12.6470588 15.5,11.4705882 15.5,10 M8,19 L8,23.5 M3,23.5 L13,23.5" id="Combined-Shape" stroke-linecap="round" stroke-linejoin="round"></path>
                    <rect id="Rectangle" x="3.5" y="0.5" width="9" height="15" rx="4.5"></rect>
                </g>
                <line x1="0.5" y1="1.5" x2="22.5" y2="19.5" id="Line-3" stroke="#F44336" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></line>
            </g>
        </g>
    </g>
</svg>
</template>
